var _rect, _path, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConferenceUserRemove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 20,
    width: 8,
    height: 2.5,
    rx: 0.5,
    fill: "#2760A3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0999 22.0005C23.1284 22.0005 24.1338 21.7072 24.989 21.1578C25.8441 20.6083 26.5107 19.8274 26.9043 18.9137C27.2978 18.0001 27.4008 16.9947 27.2002 16.0247C26.9995 15.0548 26.5043 14.1638 25.777 13.4645C25.0497 12.7652 24.1231 12.289 23.1144 12.0961C22.1057 11.9031 21.0601 12.0022 20.1099 12.3806C19.1596 12.7591 18.3475 13.4 17.7761 14.2223C17.2047 15.0446 16.8997 16.0113 16.8997 17.0003C16.8997 18.3262 17.4475 19.5987 18.4225 20.5362C19.3976 21.4738 20.721 22.0005 22.0999 22.0005ZM25.7398 23.2501H25.061C24.1325 23.6619 23.122 23.8752 22.0994 23.8752C21.0768 23.8752 20.0664 23.6619 19.1378 23.2501H18.4599C17.0117 23.2503 15.623 23.8037 14.5991 24.7884C13.5752 25.7731 13 27.1085 13 28.501V30.1251C13.0003 30.6223 13.2058 31.099 13.5714 31.4506C13.937 31.8021 14.4328 31.9997 14.9498 32H29.2499C29.767 31.9997 30.2627 31.8021 30.6283 31.4506C30.994 31.099 31.1995 30.6223 31.1997 30.1251V28.501C31.1995 27.1087 30.6242 25.7735 29.6003 24.789C28.5764 23.8045 27.1878 23.2503 25.7398 23.2501Z",
    fill: "#2760A3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.375,
    width: 45.25,
    height: 45.25,
    rx: 7.625,
    stroke: "#2760A3",
    strokeWidth: 0.75
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConferenceUserRemove);
export default __webpack_public_path__ + "static/media/conference-user-remove.d503425a6395c25221bc50a73d40e0b3.svg";
export { ForwardRef as ReactComponent };